module.exports = __webpack_public_path__ + "img/varoszoba_2.f150b518.jpg";